// extracted by mini-css-extract-plugin
export const videoModal = "videoModal-module--videoModal--WvAdy";
export const videoModalOpen = "videoModal-module--videoModalOpen--2FX3b";
export const modalBg = "videoModal-module--modalBg--3IW9f";
export const modalContentBox = "videoModal-module--modalContentBox--1NRSi";
export const modalClose = "videoModal-module--modalClose--3kn5x";
export const iframeWrap = "videoModal-module--iframeWrap--bnjq9";